export enum PricingDeal {
	Outside = 'o-rareDeal',
	Balcony = 'b-rareDeal',
	Suite = 's-rareDeal',
	None = 's-noDeal',
}
